"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ListingRelatedListModel_1 = require("./ListingRelatedListModel");
var ListingActivityListModel = /** @class */ (function (_super) {
    __extends(ListingActivityListModel, _super);
    function ListingActivityListModel(listing) {
        return _super.call(this, listing) || this;
    }
    ListingActivityListModel.prototype._loadImpl = function () {
        return this.listingService.getListingActivity({ listingId: this.listing.id });
    };
    return ListingActivityListModel;
}(ListingRelatedListModel_1.ListingRelatedListModel));
exports.ListingActivityListModel = ListingActivityListModel;
